import React from 'react';
import '../styles/usecase.css';


const Usecase= () => {

    return(
        <div className='usecase'>
        <h4 style={{color:'#FFD52B'}}>Use Case</h4>
        <hr></hr>
        <div className='row' style={{columnGap:'20px',rowGap:'20px'}} >
            <div className='col-12 col-md-5  usecase-col-1'>
                <div className='usecase-row usecase-row-1'>
                <h4>Material Handling in Logistics</h4>
                <p>Robots automate loading, unloading, and transportation in warehouses, reducing costs and increasing efficiency</p>

                </div>
                <div className='usecase-row usecase-row-2'>
                <h4>Surgical Assistance in Healthcare</h4>
                <p>Precision robots assist surgeons in performing minimally invasive procedures, enhancing patient outcomes.</p>
                </div>
                
            </div>
            <div className='col-12 col-md-3  usecase-col-2'>
                <h4>Pick-and-Place Operations in Manufacturing</h4>
                <p>Robots handle repetitive tasks like assembly and packaging, boosting production rates</p>
            </div>
            <div className='col-12 col-md-3  usecase-col-3'> 
                <h4>Shelf Scanning in Retail</h4>
                <p>Autonomous robots monitor inventory and optimize stock levels in real time.</p>
            </div>
            
        </div>

        </div>
    );



}

export default Usecase;